import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavbarService {

  // Subject para notificar quando as fazendas devem ser atualizadas
  private atualizarFazendasSubject = new Subject<void>();

  // Observable que os componentes podem se inscrever
  atualizarFazendas$ = this.atualizarFazendasSubject.asObservable();

  constructor() { }

  /**
   * Método para notificar todos os inscritos que as fazendas devem ser atualizadas
   */
  notificarAtualizacaoFazendas(): void {
    this.atualizarFazendasSubject.next();
  }
}

